import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import FeaturesSetupTopPanelLeft from "./FeaturesSetupTopPanelLeft";
import FeaturesSetupTopPanelCenter from "./FeaturesSetupTopPanelCenter";
import FeaturesFilters from "../FeatureCreator/FeaturesFilters/FeaturesFilters";
import {SortByMode} from "../ProjectScope/SortByMode";
import {AccessRights} from "../../schemas/accessRightsModel";
import {usePrevious} from "../../utilities/helperHooks";
import featureCreatorNewActions from './../FeatureCreator/FeatureCreatorNewActions';
import {featuresSetupShowMarkUpDownPopup, featuresSetupShowShippingSetupPopup} from "./featuresActions";
import SvgIcons from "../Icons/SvgIcons";

const TOP_PANEL_WIDTH = 90;

const FeaturesSetupTopPanel = (props) => {

  const {showMode, activeMode, setMode, currentScroll, featuresSetupShowShippingSetupPopup,
    featuresSetupShowMarkUpDownPopup} = props;
  const [panelState, setPanelState] = useState("");
  const prevScroll = usePrevious(currentScroll);

  useEffect(() => {
    // console.log("currentScroll", currentScroll);
    // console.log("prevScroll", prevScroll);
    if ((currentScroll < TOP_PANEL_WIDTH) && panelState) {
      setPanelState("");
    } else if (panelState !== "up" && (currentScroll < prevScroll) && (currentScroll > TOP_PANEL_WIDTH)) {
      setPanelState("up");
    } else if ((panelState !== "down") && (currentScroll > prevScroll)) {
      setPanelState("down");
    }
  }, [currentScroll])

  return (
    <div className={"fs-top" + (panelState ? " fs-top--scrolling-" + panelState : "")}>
      <FeaturesSetupTopPanelLeft/>
      <FeaturesSetupTopPanelCenter/>
      <div className="fs-top__item fs-top__item--right">
        <button className="filters-button" onClick={() => featuresSetupShowMarkUpDownPopup(true)}>
          <span className="filters-button__text">
            <FormattedMessage id="features.setup.top.markButton"/>
          </span>
          <span className="filters-button__icon filters-button__icon--mark-up-down">
            {SvgIcons.upDown}
          </span>
        </button>
        <button className="filters-button" onClick={() => featuresSetupShowShippingSetupPopup(true)}>
          <span className="filters-button__text">
            <FormattedMessage id="features.setup.top.shippingButton"/>
          </span>
          <span className="filters-button__icon filters-button__icon--shipping">
            {SvgIcons.total}
          </span>
        </button>
        <FeaturesFilters featuresSetupPage={true}/>
        {showMode ? <SortByMode onItemClick={(item) => setMode(item)}

                                selectedItem={activeMode}/> : null}
      </div>
    </div>
  )
};

FeaturesSetupTopPanel.propTypes = {
  currentScroll: PropTypes.number
}

const mapStateToProps = (store) => {
  const {activeMode} = store.featuresCreatorNew;
  const {hasKitchenSub, hasBathroomSub} = store.auth;
  const AR = AccessRights.get(store);

  return {
    activeMode,
    showMode: hasKitchenSub === hasBathroomSub || AR.isSiteAdmin(false),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMode: (mode) => dispatch(featureCreatorNewActions.setMode(mode)),
    featuresSetupShowShippingSetupPopup: (show) => dispatch(featuresSetupShowShippingSetupPopup(show)),
    featuresSetupShowMarkUpDownPopup: (show) => dispatch(featuresSetupShowMarkUpDownPopup(show))
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupTopPanel)
